import { useTypewriter } from '../hooks/useTypewriter';

const sentences = [
    "acting before risks are fully examined",
    "deciding before exploring every angle",
    "letting urgency outpace your insight"
];

export const Hero = () => {
    // text, speed, delay, deleteSpeed, pauseTime
    const typedText = useTypewriter(sentences, 50, 500, 30, 4000);

    return (
        <section className="hero" id="hero">
            <div className="hero__bg-shapes" aria-hidden="true">
                <div className="shape shape--1"></div>
                <div className="shape shape--2"></div>
                <div className="shape shape--3"></div>
            </div>
            <div className="container hero__container">
                <div className="hero__content">
                    <span className="hero__badge">✨ AI-Assisted Financial Reflection</span>
                    <h1 className="hero__title">
                        {sentences.map((sentence, index) => (
                            <div key={index} className="hero__title-layer" aria-hidden="true" style={{ visibility: 'hidden', pointerEvents: 'none' }}>
                                The greatest risk is <span className="typing-cursor">{sentence}</span>
                            </div>
                        ))}
                        <div className="hero__title-layer">
                            The greatest risk is <span className="text-gradient typing-cursor">{typedText}</span>
                        </div>
                    </h1>
                    <p className="hero__description">
                        Magnolia Agentic Medley (MAM) is an AI-assisted information platform designed to provide families with a structured environment for financial reflection and information.
                    </p>
                    <p className="hero__description">
                        Expand your perspective, evaluate hidden risks from every angle, and think wisely before taking action in a complex financial world.
                    </p>
                    <div className="hero__actions">
                        <span className="btn btn--primary btn--coming-soon">Coming Soon</span>
                    </div>
                </div>
                <div className="hero__visual">
                    <div className="dashboard-preview">
                        <img
                            src="/assets/dashboard-preview.jpg"
                            alt="MAM Stewardship Dashboard showing Reflection Space, Guardian Oversight, and Health Enumeration features"
                            className="dashboard-image"
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};